import * as Sentry from '@sentry/react';
import { user } from 'packages/lib/auth';

export const logError = (
  err: unknown,
  toConsole = true,
  warn = false
): void => {
  void user().then((user) => {
    Sentry.captureException(user ? `[${user?.email}]${err}` : err);
  });
  Sentry.captureException(err);
  if (toConsole) {
    const log = warn ? console.warn : console.error;
    log(err);
  }
};
